module.exports = __webpack_public_path__ + "img/avg.d6e8bc62.svg";